const RelatedCollections = () => {
  const selectors = {
    section: ".related-collections",
    track: ".js-related-collections-track"
  };

  async function init(sectionId) {
    const Swiper = window.themeCore.utils.Swiper;

    const sections = [...document.querySelectorAll(selectors.section)].filter(
      (el) => !sectionId || el.closest(`#shopify-section-${sectionId}`)
    );

    sections.forEach((section) => {
      const track = section.querySelector(selectors.track);
      if (!track) return;

      new Swiper(track, {
        slidesPerView: "auto",
        spaceBetween: 12,
        grabCursor: true,
        slidesOffsetAfter: 20,
        breakpoints: {
          768: {
            spaceBetween: 20,
            slidesOffsetAfter: 40
          }
        }
      });
    });
  }

  return Object.freeze({ init });
};

const action = () => {
  window.themeCore.RelatedCollections = window.themeCore.RelatedCollections || RelatedCollections();
  window.themeCore.utils.register(window.themeCore.RelatedCollections, "related-collections");
};

if (window.themeCore && window.themeCore.loaded) {
  action();
} else {
  document.addEventListener("theme:all:loaded", action, { once: true });
}
